
import React from 'react';
import { PasswordCriteriaList } from './PasswordCriteriaList';

interface PasswordCriteria {
  hasLowercase: boolean;
  hasUppercase: boolean;
  hasNumber: boolean;
  hasSpecial: boolean;
  isLongEnough: boolean;
}

interface PasswordStrengthIndicatorProps {
  password: string;
  criteria: PasswordCriteria;
  strength: "weak" | "medium" | "strong" | null;
}

export const PasswordStrengthIndicator: React.FC<PasswordStrengthIndicatorProps> = ({
  password,
  criteria,
  strength
}) => {
  if (!password) return null;

  return (
    <div className="mt-2">
      <div className="flex items-center justify-between mb-1">
        <span className="text-xs text-white/70">
          Força da senha: 
          <span className={strength === "weak" ? "text-red-500 ml-1" : strength === "medium" ? "text-yellow-500 ml-1" : "text-green-500 ml-1"}>
            {strength === "weak" && "Fraca"}
            {strength === "medium" && "Média"}
            {strength === "strong" && "Forte"}
          </span>
        </span>
      </div>
      <div className="w-full h-1 bg-white/10 rounded-full overflow-hidden">
        <div className={`h-full transition-all duration-300 ${strength === "weak" ? "bg-red-500 w-1/3" : strength === "medium" ? "bg-yellow-500 w-2/3" : "bg-green-500 w-full"}`} />
      </div>
      
      <PasswordCriteriaList criteria={criteria} />
    </div>
  );
};

export default PasswordStrengthIndicator;
